export * from "@/configuration/document-mappings/types";
import type { DocumentMappingRegistry } from "@/configuration/document-mappings/types";
import { ACS_MAPPINGS } from "@/configuration/groups/acs/document-mappings";
import { ADSS_MAPPINGS } from "@/configuration/groups/adss/document-mappings";
import { APEX_MAPPINGS } from "@/configuration/groups/apex/document-mappings";
import { AUTONOMY_MAPPINGS } from "@/configuration/groups/autonomy/document-mappings";
import { BALANCE_HEALTH_MAPPINGS } from "@/configuration/groups/balance-health/document-mappings";
import { CONFLUENT_ALL_STAR_MAPPINGS } from "@/configuration/groups/confluent-all-star/document-mappings";
import { CONVENIENT_MD_MAPPINGS } from "@/configuration/groups/convenientmd/document-mappings";
import { COUG_MAPPINGS } from "@/configuration/groups/coug/document-mappings";
import { ENTP_MAPPINGS } from "@/configuration/groups/entpartners/document-mappings";
import { ENTS_MAPPINGS } from "@/configuration/groups/ents/document-mappings";
import { NVISION_EWEI_TORRANCE_MAPPINGS } from "@/configuration/groups/ewei-torrance/document-mappings";
import { FCC_MAPPINGS } from "@/configuration/groups/fcc/document-mappings";
import { HVC_MAPPINGS } from "@/configuration/groups/hvc/document-mappings";
import { INSIGHT_MAPPINGS } from "@/configuration/groups/insight/document-mappings";
import { MENT_MAPPINGS } from "@/configuration/groups/ment/document-mappings";
import { NIMBUS_MAPPINGS } from "@/configuration/groups/nimbus/document-mappings";
import { NIRA_MAPPINGS } from "@/configuration/groups/nira/document-mappings";
import { PACESETTER_MAPPINGS } from "@/configuration/groups/pacesetter/document-mappings";
import { PA_CENTRAL_MAPPINGS } from "@/configuration/groups/pediatricassociates-central/document-mappings";
import { PA_EAST_MAPPINGS } from "@/configuration/groups/pediatricassociates-east/document-mappings";
import { PINNACLE_MAPPINGS } from "@/configuration/groups/pinnacle/document-mappings";
import { PPCP_MAPPINGS } from "@/configuration/groups/ppcp/document-mappings";
import { QOROS_MAPPINGS } from "@/configuration/groups/qoros/document-mappings";
import { QOROS_CFCG_MAPPINGS } from "@/configuration/groups/qoros-cfcg/document-mappings";
import { SIENT_MAPPINGS } from "@/configuration/groups/sient/document-mappings";
import { TEXAS_HEART_SOUTH_HEART_MAPPINGS } from "@/configuration/groups/south-heart/document-mappings";
import { SPORTORTHO_MAPPINGS } from "@/configuration/groups/sportortho/document-mappings";
import { STRIDECARE_MAPPINGS } from "@/configuration/groups/stridecare/document-mappings";
import { CVVC_MAPPINGS } from "@/configuration/groups/stridecare-cvvc/document-mappings";
import { FID_MAPPINGS } from "@/configuration/groups/stridecare-fid/document-mappings";
import { TRICITY_MAPPINGS } from "@/configuration/groups/tco/document-mappings";
import { UPPERLINE_MAPPINGS } from "@/configuration/groups/upperline-fl/document-mappings";
import { USHV_CCOH_MAPPINGS } from "@/configuration/groups/ushv-ccoh/document-mappings";
import { USHV_FORTWORTH_MAPPINGS } from "@/configuration/groups/ushv-fortworth/document-mappings";
import { HEARTPLACE_MAPPINGS } from "@/configuration/groups/ushv-heartplace/document-mappings";
import { USHV_MCA_MAPPINGS } from "@/configuration/groups/ushv-mca/document-mappings";
import { USHV_MKC_MAPPINGS } from "@/configuration/groups/ushv-mkc/document-mappings";
import { USHV_ORION_MAPPINGS } from "@/configuration/groups/ushv-orion/document-mappings";
import { USHV_PIMA_MAPPINGS } from "@/configuration/groups/ushv-pima/document-mappings";
import { USRC_CPS_MAPPINGS } from "@/configuration/groups/usrc-cps/document-mappings";
import { VPS_MAPPINGS } from "@/configuration/groups/vps/document-mappings";
import { ConfigSubdomain } from "@/configuration/tenant-ids";

export {
  ACS_MAPPINGS,
  ADSS_MAPPINGS,
  APEX_MAPPINGS,
  AUTONOMY_MAPPINGS,
  BALANCE_HEALTH_MAPPINGS,
  CONFLUENT_ALL_STAR_MAPPINGS,
  CONVENIENT_MD_MAPPINGS,
  COUG_MAPPINGS,
  CVVC_MAPPINGS,
  ENTP_MAPPINGS,
  ENTS_MAPPINGS,
  FCC_MAPPINGS,
  HVC_MAPPINGS,
  INSIGHT_MAPPINGS,
  MENT_MAPPINGS,
  NIMBUS_MAPPINGS,
  NIRA_MAPPINGS,
  NVISION_EWEI_TORRANCE_MAPPINGS,
  PINNACLE_MAPPINGS,
  HEARTPLACE_MAPPINGS,
  PACESETTER_MAPPINGS,
  PA_CENTRAL_MAPPINGS,
  PA_EAST_MAPPINGS,
  PPCP_MAPPINGS,
  QOROS_CFCG_MAPPINGS,
  QOROS_MAPPINGS,
  SIENT_MAPPINGS,
  SPORTORTHO_MAPPINGS,
  TEXAS_HEART_SOUTH_HEART_MAPPINGS,
  STRIDECARE_MAPPINGS,
  TRICITY_MAPPINGS,
  UPPERLINE_MAPPINGS,
  USHV_CCOH_MAPPINGS,
  USHV_FORTWORTH_MAPPINGS,
  USHV_MCA_MAPPINGS,
  USHV_MKC_MAPPINGS,
  USHV_ORION_MAPPINGS,
  USHV_PIMA_MAPPINGS,
  USRC_CPS_MAPPINGS,
  VPS_MAPPINGS,
};

export function getMappingsForGroup(group: string): DocumentMappingRegistry {
  switch (group) {
    case ConfigSubdomain.ACS:
      return ACS_MAPPINGS;
    case ConfigSubdomain.ADSS:
      return ADSS_MAPPINGS;
    case ConfigSubdomain.APEX:
      return APEX_MAPPINGS;
    case ConfigSubdomain.CONVENIENT_MD:
      return CONVENIENT_MD_MAPPINGS;
    case ConfigSubdomain.COUG:
      return COUG_MAPPINGS;
    case ConfigSubdomain.CVVC:
      return CVVC_MAPPINGS;
    case ConfigSubdomain.STRIDECARE_FID:
      return FID_MAPPINGS;
    case ConfigSubdomain.ENT_PARTNERS:
      return ENTP_MAPPINGS;
    case ConfigSubdomain.ENT_PARTNERS_ENTS:
      return ENTS_MAPPINGS;
    case ConfigSubdomain.ENT_PARTNERS_MENT:
      return MENT_MAPPINGS;
    case ConfigSubdomain.NIMBUS:
      return NIMBUS_MAPPINGS;
    case ConfigSubdomain.NIRA:
      return NIRA_MAPPINGS;
    case ConfigSubdomain.NVISION_EWEI_TORRANCE:
      return NVISION_EWEI_TORRANCE_MAPPINGS;
    case ConfigSubdomain.QOROS_BC:
      return QOROS_MAPPINGS;
    case ConfigSubdomain.QOROS_CFCG:
      return QOROS_CFCG_MAPPINGS;
    case ConfigSubdomain.PINNACLE:
      return PINNACLE_MAPPINGS;
    case ConfigSubdomain.FCC:
      return FCC_MAPPINGS;
    case ConfigSubdomain.SIENT:
      return SIENT_MAPPINGS;
    case ConfigSubdomain.SPORTORTHO:
      return SPORTORTHO_MAPPINGS;
    case ConfigSubdomain.VALERIE:
      return PINNACLE_MAPPINGS; // Valerie uses Pinnacle mappings for now
    case ConfigSubdomain.VALERIE_HEALTH_TRAINING:
      return HEARTPLACE_MAPPINGS;
    case "demo":
      return PINNACLE_MAPPINGS;
    case ConfigSubdomain.USHV_HEARTPLACE:
      return HEARTPLACE_MAPPINGS;
    case ConfigSubdomain.HVC:
      return HVC_MAPPINGS;
    case ConfigSubdomain.INSIGHT:
      return INSIGHT_MAPPINGS;
    case ConfigSubdomain.AUTONOMY:
      return AUTONOMY_MAPPINGS;
    case ConfigSubdomain.BALANCE_HEALTH:
      return BALANCE_HEALTH_MAPPINGS;
    case ConfigSubdomain.CONFLUENT_ALL_STAR:
      return CONFLUENT_ALL_STAR_MAPPINGS;
    case ConfigSubdomain.STRIDECARE:
      return STRIDECARE_MAPPINGS;
    case ConfigSubdomain.TRICITY:
      return TRICITY_MAPPINGS;
    case ConfigSubdomain.UPPERLINE_FLORIDA:
    case ConfigSubdomain.UPPERLINE_GEORGIA:
    case ConfigSubdomain.UPPERLINE_INDIANA:
    case ConfigSubdomain.UPPERLINE_TENNESSEE:
      return UPPERLINE_MAPPINGS;
    case ConfigSubdomain.TEXAS_HEART_SOUTH_HEART:
      return TEXAS_HEART_SOUTH_HEART_MAPPINGS;
    case ConfigSubdomain.USHV_CCOH:
      return USHV_CCOH_MAPPINGS;
    case ConfigSubdomain.USHV_FORTWORTH:
      return USHV_FORTWORTH_MAPPINGS;
    case ConfigSubdomain.USHV_MCA:
      return USHV_MCA_MAPPINGS;
    case ConfigSubdomain.USHV_MKC:
      return USHV_MKC_MAPPINGS;
    case ConfigSubdomain.USHV_ORION:
      return USHV_ORION_MAPPINGS;
    case ConfigSubdomain.USHV_PIMA:
      return USHV_PIMA_MAPPINGS;
    case ConfigSubdomain.USRC_CPS_AK:
    case ConfigSubdomain.USRC_CPS_CO:
      return USRC_CPS_MAPPINGS;
    case ConfigSubdomain.VPS:
      return VPS_MAPPINGS;
    case ConfigSubdomain.PA_CENTRAL_REGION:
      return PA_CENTRAL_MAPPINGS;
    case ConfigSubdomain.PA_EAST_REGION:
      return PA_EAST_MAPPINGS;
    case ConfigSubdomain.PACESETTER:
      return PACESETTER_MAPPINGS;
    case ConfigSubdomain.PPCP:
      return PPCP_MAPPINGS;
    default:
      throw new Error(`No document mappings defined for group: ${group}`);
  }
}
